import { Theme } from "@mui/material";


export const VariantStyles = (theme: Theme, hasBackground: boolean, hasIcon: boolean) => {
    return {
      info: {
        color: theme.colors["yellow.300"],
        ...(hasBackground && {
            color: theme.colors["yellow.950"],
            backgroundColor: theme.colors["yellow.300"]
        }),
        ...(!hasIcon && {
          padding: `${theme.space._100} ${theme.space._200}`
        })
      },
      error: {
        color: theme.colors["red.500"],
        ...(hasBackground && {
            color: theme.colors["red.950"],
            backgroundColor: theme.colors["red.400"]
        }),
        ...(!hasIcon && {
          padding: `${theme.space._100} ${theme.space._200}`
        })
      }
    };
  };

export const SizeStyles = (theme: Theme) => {
    return {
        sm: {
            fontSize: theme.fontSizes.xs,
        },
        md: {
            fontSize: theme.fontSizes.sm,
        },
        lg: {
            fontSize: theme.fontSizes.md,
        }
    };
};